import * as React from "react"
import { Stack, Button, Divider, Typography } from "@mui/material"
import { ITransaction } from "@/types/transaction"
import { useTranslation } from "react-i18next"
import FinancialDetailItem from "./detail-item"
import PaymentDetailsRenderer from "../payment-details/payment-details-renderer"
import { humanDate } from "@/utils"
import copy from "copy-to-clipboard"
import ModalContent from "../../property-card/details/ModalContent"
import { useGlobalContext } from "@/context/global-context"

interface IFinancialDetailsProps {
  item: any
}

const FinancialDetails: React.FunctionComponent<IFinancialDetailsProps> = ({
  item,
}) => {
  //getting translation object
  const { t } = useTranslation()

  const { showModal, closeModal } = useGlobalContext();

  // Function to handle opening Faraboors modal
  const openFaraboorsHandler = (farabourse_trace_code: string) => {
    if (!farabourse_trace_code) return;
    copy(farabourse_trace_code); // Replace `projectSymbol` with trace code if needed
    showModal(<ModalContent symbol={farabourse_trace_code} onClose={closeModal} />, {
      width: ["100%", , 500],
    });
  }


  return (
    <Stack spacing={2}>
      <FinancialDetailItem
        title={t("transaction_title")}
        value={item?.transactionable?.title}
      />
      <Divider />
      <FinancialDetailItem title={t("payer")} value={item.payer} />
      <Divider />
      <FinancialDetailItem
        title={t("receiver")}
        value={item?.transactionable?.owner_name || "="}
      />
      <Divider />
      <FinancialDetailItem
        title={t("amount_of_transaction")}
        value={(item?.quantity || 0)?.withCommas()?.withPriceUnit()}
      />
      <Divider />
      <FinancialDetailItem title={t("date")} value={humanDate(item.created_at, "jYYYY-jMM-jDD , HH:mm:ss")} />
      <Divider />
      <Stack direction={"row"} justifyContent="flex-end">
        <FinancialDetailItem
          direction='column'
          title={t("tracking_code")}
          value={item?.reference_id}
          alignItems='flex-start'
        />
        {item?.meta?.farabourse_trace_code ? (
          <Button
            onClick={() => openFaraboorsHandler(item?.meta?.farabourse_trace_code)}
            disableRipple
            sx={{
              p: 0,
              bgcolor: "#E29314", // Background color
              color: "#FFFFFF",   // Text color for contrast
              border: "1px solid #E29314", // Border color
              borderRadius: "4px", // Optional: Border radius for rounded corners
              "&:hover": {
                bgcolor: "#D98212", // Darker shade for hover effect
              },
            }}
            variant="text"
          >
            <Typography sx={{ color: "#FFFFFF" }} variant="smallBold">
              {t("common:inquiry_investment_fraborse")}
            </Typography>
          </Button>

        ) : (
          "-"
        )}
      </Stack>
      <Divider />
      <Stack direction={"row"} justifyContent="end">
        <PaymentDetailsRenderer item={item} />
      </Stack>
    </Stack>
  )
}

export default FinancialDetails
